
const constCookieAlertVisibleKey = 'cookie-alert-checked';

export function getCookieAlertVisible () {
  const result = window.localStorage.getItem(constCookieAlertVisibleKey);
  return !result;
}

export function hideCookieAlert () {
  window.localStorage.setItem(constCookieAlertVisibleKey, true);
}
